var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yd-dialog",
    {
      attrs: {
        title: "结算通知",
        visible: _vm.dialogVisible,
        width: "30%",
        "before-close": _vm.handleClose,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "flex flex-col",
          staticStyle: { "min-height": "100px" },
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.initData.company))]),
          _c("span", [_vm._v(_vm._s(_vm.initData.time))]),
          _c("div", [
            _c("span", [_vm._v(_vm._s(_vm.initData.remark))]),
            _c(
              "span",
              {
                staticClass: "pointer color-main margin-left-10 font-weight",
                on: { click: _vm.download },
              },
              [_vm._v("点击下载")]
            ),
          ]),
        ]
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleClose } },
            [_vm._v("知道了")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }